import { z } from 'zod';

export const tagSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  category: z.string().nullable(),
});
export type Tag = z.infer<typeof tagSchema>;

export const tagSchemaWithoutId = tagSchema.omit({ id: true });

export const tagsQuerySchema = z.object({
  operator: z.enum(['AND', 'OR']),
  tags: z.array(tagSchemaWithoutId),
});
export type TagsQuery = z.infer<typeof tagsQuerySchema>;

export interface FindAllOptions {
  name?: string | string[];
  organizationId?: string | null;
  category?: string | null;
}
